import * as React from "react"
import '../styles/global.css'
import { useBrain } from "../../Brain";
import * as styles from '../styles/public.module.css'
import { useEffect } from "react";
import { useLocation } from "@reach/router"  // provides access to the current location

import useEnsureMobile from "../functions/useEnsureMobile";

export default function Public() {

  const mobile = useEnsureMobile('tabletSmall').ensureMobile

  const { authReady, user, login, logout, setRedirectedFrom } = useBrain();

  return (
    <div className={styles.page}>

      <div className={styles.all}>


        <h1>ASK GEMIC</h1>



        {/* <p>Log in via Google using Gemic account</p> */}
        {!mobile &&
          <div
            onClick={() => authReady && !user && login()}
            className={styles.loginButton}
            style={{ opacity: authReady && !user ? 1 : 0.5, cursor: authReady && !user ? 'pointer' : 'default' }}
          >
            Login
          </div>
        }
        {mobile && 
        <p>
          This is a desktop only app. Please use a desktop to access it.
        </p>

        }


      </div>
    </div>

  );
}

export { Head } from '../components/Head'
